module.exports = __webpack_public_path__ + "66bb7f208269cad9055c6a80ef4530a7.jpg";